<template>
    <div class="flex flex-col items-center justify-center h-full"   :class="[isActive ? 'font-bold' : '', label === 'Campaign Info' ? 'mt-3' : '']" >

      <svg v-if="isCurrent" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
        <circle cx="12.5" cy="12.5" r="12.5" fill="#369da3" />
      </svg>
      <svg v-else-if="isCompleted" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
        <circle cx="12.5" cy="12.5" r="12.5" fill="#369da3" />
        <path d="M7 12.5l3 3 6-6" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
        <circle cx="12.5" cy="12.5" r="12.5" fill="none" stroke="#000" />
      </svg>
      <p class="mt-2">{{ label }}</p>
    </div>
    <!-- Line Divider -->
    <div class="mx-auto flex flex-row items-center justify-center h-full" v-if="label=='Campaign Info' || label=='Targeting'">
      <img src="../../assets/Line.svg" />
    </div>
  </template>
  
  <script>
  export default {
    props: {
      step: Number,
      currentStep: Number,
      label: String,
    },
    computed: {
      isCurrent() {
        return this.step === this.currentStep;
      },
      isCompleted() {
        return this.step < this.currentStep;
      },
    },
  };
  </script>
